<h5 style="margin-top: 20px;">Linked Workday Finance Projects</h5>

@if (project.projectFinanceProjects.length) {
  <div class="results-grid" [ngClass]="{'stubby': project.projectFinanceProjects.length <= 8}">
    <div class="results-header">
      <div>WD Project ID</div>
      <div>WD Status</div>
      <div>WD Project Name</div>
      <!-- <div>Business Unit</div> -->
      <div>Link Created By</div>
      <div>Link Created On</div>
    </div>

    <div class="results-body">
      @for (pfp of project.projectFinanceProjects; track pfp) {
        <div class="result-row">
          <div>
            {{pfp.financeProject.workdayCode}}
          </div>
          <div>
            {{pfp.financeProject.status}}
          </div>
          <div>
            {{pfp.financeProject.name}}
          </div>
          <!-- <div>
          {{pfp.financeProject.businessUnitName ? pfp.financeProject.businessUnitName : '(No BU in Workday)'}}
        </div> -->
        <div>
          {{pfp.createdByUser.fullName}}
        </div>
        <div>
          {{pfp.createdOn | date:'dd-MMM-yyyy'}}
        </div>
      </div>
    }
  </div>
</div>
}
@else {
<div>There is no information to display</div>
}
